<template>
  <main class="troodon-main">
    <slot></slot>
  </main>
</template>

<style scoped lang="scss">
.troodon-main {
  padding: 24px 16px;

  @media (min-width: 600px) {
    max-width: 600px;
    margin-right: auto;
    margin-left: auto;
  }
}
</style>
